// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   postalcode: null,
//   loading: false,
//   error: null,
// };

// const orderSlice = createSlice({
//   name: "orders",
//   initialState,
//   reducers: {
//     setPincode: (state, action) => {
//       console.log("Setting pincode in orderSlice:", action.payload);
//       state.postalcode = action.payload;
//     },
//   },
// });

// export const { setPincode } = orderSlice.actions;
// export default orderSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  postalcode: null,
  loading: false,
  error: null,
};

const orderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setPincode: (state, action) => {
      console.log("Setting pincode in orderSlice:", action.payload);
      state.postalcode = action.payload;
    },
    clearPincode: (state) => {
      console.log("Clearing pincode from orderSlice");
      state.postalcode = null;
    },
  },
});

export const { setPincode, clearPincode } = orderSlice.actions;
export default orderSlice.reducer;